import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ServiceDetailPage = lazy(() => import('../pages/service-detail/page'));
const OffresPage = lazy(() => import('../pages/offres/page'));
const BoutiquePage = lazy(() => import('../pages/boutique/page'));
const ProduitPage = lazy(() => import('../pages/boutique/produit/page'));
const PanierPage = lazy(() => import('../pages/boutique/panier/page'));
const AcademyPage = lazy(() => import('../pages/academy/page'));
const AcademyDetailPage = lazy(() => import('../pages/academy-detail/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogDetailPage = lazy(() => import('../pages/blog-detail/page'));
const RealisationsPage = lazy(() => import('../pages/realisations/page'));
const RealisationDetailPage = lazy(() => import('../pages/realisation-detail/page'));
const ClientLoginPage = lazy(() => import('../pages/client-space/login/page'));
const ClientDashboardPage = lazy(() => import('../pages/client-space/dashboard/page'));
const ResetPasswordPage = lazy(() => import('../pages/client-space/reset-password/page'));
const AdminLoginPage = lazy(() => import('../pages/admin/login/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin/dashboard/page'));
const AdminSetupPasswordPage = lazy(() => import('../pages/admin/setup-password/page'));
const AdminResetPasswordPage = lazy(() => import('../pages/admin/reset-password/page'));
const ContractSignPage = lazy(() => import('../pages/contract-sign/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/services/:id',
    element: <ServiceDetailPage />,
  },
  {
    path: '/offres',
    element: <OffresPage />,
  },
  {
    path: '/boutique',
    element: <BoutiquePage />,
  },
  {
    path: '/boutique/produit/:id',
    element: <ProduitPage />,
  },
  {
    path: '/boutique/panier',
    element: <PanierPage />,
  },
  {
    path: '/academy',
    element: <AcademyPage />,
  },
  {
    path: '/academy/:id',
    element: <AcademyDetailPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogDetailPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/realisations',
    element: <RealisationsPage />,
  },
  {
    path: '/realisations/:id',
    element: <RealisationDetailPage />,
  },
  {
    path: '/client-space/login',
    element: <ClientLoginPage />,
  },
  {
    path: '/client-space/dashboard',
    element: <ClientDashboardPage />,
  },
  {
    path: '/client-space/reset-password',
    element: <ResetPasswordPage />,
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboardPage />,
  },
  {
    path: '/admin/setup-password',
    element: <AdminSetupPasswordPage />,
  },
  {
    path: '/admin/reset-password',
    element: <AdminResetPasswordPage />,
  },
  {
    path: '/contract/sign/:token',
    element: <ContractSignPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;